import type { UnknownAction } from '@reduxjs/toolkit';
import { createAction } from '@reduxjs/toolkit';
import type { CartItem } from 'react/checkout/Store/CartItem/state';

interface CartItemAction extends UnknownAction {
    payload: string;
    type: CartItemActionType;
}

export enum CartItemActionType {
    ADD_UPSELL_CART_ITEM = 'ADD_UPSELL_CART_ITEM',
    REMOVE_CART_ITEM = 'REMOVE_CART_ITEM',
    REMOVE_CART_ITEM_MESSAGE = 'REMOVE_CART_ITEM_MESSAGE',
    SET_ALL_CART_ITEM_DATA = 'SET_ALL_CART_ITEM_DATA',
    SET_CART_ITEM_AMOUNT = 'SET_CART_ITEM_AMOUNT',
    SET_CART_ITEM_MESSAGE = 'SET_CART_ITEM_MESSAGE',
}

export type RemoveCartItemPayload = { id: string };
export const removeCartItem = createAction<RemoveCartItemPayload>(CartItemActionType.REMOVE_CART_ITEM);

export type RemoveCartItemMessagePayload = { id: string };
export const removeCartItemMessage = createAction<RemoveCartItemMessagePayload>(CartItemActionType.REMOVE_CART_ITEM_MESSAGE);

export type SetAllCartItemDataPayload = { cartContainsAlcohol: boolean; cartContainsStrongAlcohol: boolean; items: Record<string, CartItem> };
export const setAllCartItemData = createAction<SetAllCartItemDataPayload>(CartItemActionType.SET_ALL_CART_ITEM_DATA);

export type SetCartItemAmountPayload = { amount: string; id: string };
export const setCartItemAmount = createAction<SetCartItemAmountPayload>(CartItemActionType.SET_CART_ITEM_AMOUNT);

export type SetCartItemMessagePayload = { id: string; message: string };
export const setCartItemMessage = createAction<SetCartItemMessagePayload>(CartItemActionType.SET_CART_ITEM_MESSAGE);

export type AddCartItemPayload = { amount?: number; parentCartItemId: number; parentProductId: number; productId: number; upsellGroupId: number };
export const addCartItem = createAction<AddCartItemPayload>(CartItemActionType.ADD_UPSELL_CART_ITEM);

export type { CartItemAction };
